<ion-row class="row ion-text-center" *ngIf="match._id">
    <ion-col id="startLiveScore" *ngIf="!canScoreMatch() && match.matchStatus === 'TBP'" class="tracker-bar">
        <ion-button class="bar-button" color="gray" (click)="manageLiveScore(['LIVE_SCORE'])" expand="block" fill="clear">
            <div>
                <ion-icon name="radio-outline"></ion-icon>
                <span>{{ 'Start live score' | translate }}</span>
            </div>
        </ion-button>
    </ion-col>

    <ion-col id="shareMatch" *ngIf="match._id">
        <app-share-match [matchId]="match._id" [position]="'change-tracker'"></app-share-match>
    </ion-col>

    <ion-col id="startMatch" *ngIf="canScoreMatch() && match?.matchStatus === 'TBP'">
        <app-start-match [match]="match" itemStyle="button"></app-start-match>
    </ion-col>

    @if (match.matchStatus !=='TBP' && match._id) {
        <ion-col id="undo">
            <ion-button class="bar-button" color="gray" (click)="undo.emit()" expand="block" fill="clear">
                <div>
                    <ion-icon name="arrow-undo"></ion-icon>
                    <span>{{ 'Undo' | translate }}</span>
                </div>
            </ion-button>
        </ion-col>
    }

    <ion-col class="tracker-bar" *ngIf="batteryInfo && false">
        <ion-button class="bar-button" color="gray" expand="block" fill="clear">
            <div>
                <ion-icon *ngIf="batteryInfo.isCharging" name="battery-charging-outline"></ion-icon>
                <ion-icon *ngIf="!batteryInfo.isCharging" [name]="batteryIcon"></ion-icon>
                <span>{{ (batteryInfo.batteryLevel * 100).toFixed(0) }}%</span>
            </div>
        </ion-button>
    </ion-col>

    <ion-col id="allowScoreSubmissionToPartner" *ngIf="allowScoreSubmissionToPartner && !allowAutoSubmitScore && match.matchStatus ==='COMPLETED'" class="tracker-bar">
        <ion-button class="bar-button" color="gray" (click)="submitScoreToPartner()" expand="block" fill="clear">
            <div>
                <ion-icon name="paper-plane"></ion-icon>
                <span>{{ 'Submit score' | translate }}</span>
            </div>
        </ion-button>
    </ion-col>

    <ion-col id="gamesOrPoints" *ngIf="canScoreMatch() && match.matchStatus ==='IN_PROGRESS' && match.discipline !== 'PICKLEBALL' && match.discipline !== 'BADMINTON' && match.discipline !== 'TABLE_TENNIS' && match.discipline !== 'SQUASH'" class="tracker-bar">
        <ion-button class="bar-button" color="gray" (click)="changeScoringType()" expand="block" fill="clear">
            <div>
                <ion-icon *ngIf="!isPointByPoint" name="tennisball-outline"></ion-icon>
                <ion-icon *ngIf="isPointByPoint" name="tennisball"></ion-icon>
                <span *ngIf="!isPointByPoint">{{ 'Games' | translate }}</span>
                <span *ngIf="isPointByPoint">{{ 'Points' | translate }}</span>
            </div>
        </ion-button>
    </ion-col>

    <!-- TODO: Uncomment this when pickleball server change is not working as expected -->
    <!-- <ion-col id="gamesOrPoints" *ngIf="canScoreMatch() && match.matchStatus ==='IN_PROGRESS' && match.discipline === 'PICKLEBALL'" class="tracker-bar">
        <ion-button class="bar-button" color="gray" (click)="changePickleballServer()" expand="block" fill="clear">
            <div>
                <ion-icon name="swap-horizontal"></ion-icon>
                <span>{{ 'Server' | translate }}</span>
            </div>
        </ion-button>
    </ion-col> -->

    <ion-col *ngIf="(scoreFormat.timedSetDuration || scoreFormat.setType === 'TIMED') && match.matchStatus === 'IN_PROGRESS'" id="more" class="tracker-bar">
        <ion-button class="bar-button" color="danger" (click)="stopTimedSet.emit()" expand="block" fill="clear">
            <div>
                <ion-icon name="stop"></ion-icon>
                <span>{{ 'Stop' | translate }}</span>
            </div>
        </ion-button>
    </ion-col>

    <!-- Show more options only if it is iOC match (not pulled from a tournament management platform) -->
    <ion-col *ngIf="match._id && !hideMatchMoreOptions" id="more" class="tracker-bar">
        <ion-button class="bar-button" color="gray" (click)="showMoreOptions()" expand="block" fill="clear">
            <div>
                <ion-icon name="apps"></ion-icon>
                <span>{{ 'More' | translate }}</span>
            </div>
        </ion-button>
    </ion-col>

</ion-row>